export const SaleStatusCssClasses = [
  'secondary',
  'warning',
  'primary',
  'success',
  'info',
  'dark',
  'danger',
  'default',
  'muted',
];
export const SaleStatusTitles = [
  'Шинэ',
  'Нэхэмжлэл үүсгэсэн',
  'Төлбөр төлөгдсөн',
  'Баталгаажсан',
  'Хүргэлтэнд өгсөн',
  'Хүргэгдсэн',
  'Урьдчилгаа төлөгдсөн',
  'Алдаа гарсан',
  'Идэвхгүй',
];
export const saleStatusList = [
  { key: -1, value: 'Төлөв' },
  { key: 0, value: 'Шинэ' }, // .text-secondary
  { key: 1, value: 'Нэхэмжлэл үүсгэсэн' }, //.text-warning
  { key: 2, value: 'Төлбөр төлөгдсөн' }, // .text-primary
  { key: 3, value: 'Баталгаажсан' }, //.text-success
  { key: 4, value: 'Хүргэлтэнд өгсөн' }, //.text-info
  { key: 5, value: 'Хүргэгдсэн' }, //.text-dark
  { key: 6, value: 'Урьдчилгаа төлөгдсөн' }, //.text-danger
  { key: 7, value: 'Алдаа гарсан' }, //.text-danger
  { key: 8, value: 'Идэвхгүй' }, //.text-muted
];

export const SaleTypeCssClasses = ['dark', 'danger'];
export const SaleTypeTitles = ['Борлуулалт', 'Урьдчилсан захиалга'];
export const saleTypeList = [
  { key: 'SALE', value: 'Борлуулалт' },
  { key: 'ORDER', value: 'Урьдчилсан захиалга' },
];

export const ChannelCssClasses = ['default', 'primary', 'success'];
export const ChannelTitles = ['Биет', 'Фэйсбүүк', 'Онлайн дэлгүүр'];
export const channelList = [
  { key: 'INPERSON', value: 'Биет' },
  { key: 'FACEBOOK', value: 'Фэйсбүүк' },
  { key: 'ECOMMERCE', value: 'Онлайн дэлгүүр' },
];

export const accountList = [
  { key: '', value: 'Данс сонгох' },
  { key: '5007999257', value: 'Хаан Банк (5007999257)' },
  { key: '452431261', value: 'Худалдаа Хөгжлийн Банк (452431261)' },
];

export const defaultSorted = [{ dataField: 'sale_code', order: 'desc' }];
export const sizePerPageList = [
  { text: '10', value: 10 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
];
export const initialFilter = {
  filter: {
    from: '', //Date.now(),
    to: '', //"",
    searchText: '',
    saleType: 'SALE',
    status: -1,
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'sale_code',
  pageNumber: 1,
  pageSize: 10,
};

export const initialSale = {
  saleCode: undefined,
  saleDate: new Date(new Date().getTime()).toISOString().slice(0, 10),
  saleType: 'SALE',
  channel: 'FACEBOOK',
  items: [],
  itemCount: 0,
  subTotalAmount: '0.00',
  discountAmount: '0.00',
  shipAmount: '4000',
  totalAmount: '4000',
  custCode: '',
  fbName: '',
  mobile: '',
  mobile2: '',
  email: '',
  location: '',
  district: '',
  address: '',
  zone: '',
  hold: 0,
  paid: 0,
  deposited: 0,
  depositAmount: '0.00',
  depositDate: undefined,
  invoice: '',
  confirmed: 0,
  status: 0,
  printShipDate: false,
  shipDate: '',
  printAccount: false,
  note: '',
  account: '',
  profit: '0',
  refCode: false,
  slipLink: '',
};
